import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { IdbStorageService } from '../services/storage/idb-storage.service';
import { storageDict } from '../services/storage/storage-dict';

@Injectable({
  providedIn: 'root',
})
export class MedRecFormatProviderService {
  private _cachedFormat = '';

  constructor(authService: AuthService, private storageService: IdbStorageService) {
    authService.authState$.subscribe((res) => {
      if (res === true) {
        this.init();
      }
    });
  }

  public init() {
    this.storageService
      .getItemSync(storageDict.klinik)
      .pipe(
        take(1),
        map((klinik) => klinik?.noRekamMedis || '')
      )
      .subscribe((res) => {
        this._cachedFormat = res;
      });
  }

  public get cachedFormat() {
    return this._cachedFormat;
  }
}

@Pipe({
  name: 'mrNumber',
})
export class MedicalRecordNumberPipe implements PipeTransform {
  constructor(private provider: MedRecFormatProviderService) {}

  transform(medicalRecord: string | number, step = 2): any {
    if (medicalRecord === '' || medicalRecord === null) return '';

    const mrFormat = this.provider.cachedFormat;

    const formatLength = mrFormat?.length || 0;
    const formatChar = '0';
    const formatted = String(medicalRecord).padStart(formatLength, formatChar);

    const regexp = new RegExp('\\d{' + step + '}|\\d+', 'g');
    const matched = String(formatted).match(regexp);
    return matched ? matched.join('-') : '-';
  }
}
